import React, { useState, useEffect } from "react";
import OtpInput from "react-otp-input";
import otpImg from "../../assests/images/otp.webp";
import { useDispatch, useSelector } from "react-redux";
import { useMemo } from "react";
import { registerService } from "../../services/auth";
import { setAuthorization } from "../../config/axios";
import { useNavigate } from "react-router-dom";
import { toastError, toastSuccess } from "../../config/ToastModal";
import otpgif from "../../assests/images/otp.json";
import Lottie from "lottie-react";
function Otp() {
  const navigate = useNavigate();
  const userData = useSelector((state) => state?.user?.userData);
  const stateUser = useMemo(() => userData, [userData]);
  const [otp, setOtp] = useState("");
  const [timer, setTimer] = useState(30);
  const [minutes, setMinutes] = useState(0);
  const [error, setError] = useState("");

  const validateOtp = () => {
    const otpRegex = /^\d{6}$/;
    if (!otpRegex.test(otp)) {
      setError("OTP must be 6 digits long and contain only numbers");
      return false;
    }
    setError("");
    return true;
  };

  const handleSubmit = async () => {
    try {
      if (validateOtp()) {
        const data = {
          firstName: stateUser?.firstName,
          // name: stateUser?.name,
          lastName: stateUser?.lastName,
          email: stateUser?.email,
          password: stateUser?.password,
          confirmPassword: stateUser?.confirmPassword,
          phoneNo: stateUser?.phoneNo,
          phoneStatus: true,
          otp: otp,
          assignedCategory: stateUser?.assignedCategory,
        };
        const response = await registerService(data);
        if (response?.status === true) {
          toastSuccess(response?.message);
          setTimeout(() => {
            navigate("/dashboard");
          }, 800);
          setAuthorization(response?.token);
        } else {
          toastError(response?.errors?.otp);
          localStorage.clear();
        }
      }
    } catch (error) {
      toastError(error?.response?.data?.errors?.email);
    }
  };

  const resendOtp = async () => {
    try {
      setMinutes(0);
      setTimer(30);
      const data = {
        firstName: stateUser?.firstName,
        lastName: stateUser?.lastName,
        email: stateUser?.email,
        password: stateUser?.password,
        confirmPassword: stateUser?.confirmPassword,
        phoneNo: stateUser?.phoneNo,
        otp: "",
        phoneStatus: false,
      };
      const response = await registerService(data);

      if (response) {
        toastSuccess("OTP send Successfully");
      }
    } catch (error) {}
  };

  useEffect(() => {
    const interval = setInterval(() => {
      if (timer > 0) {
        setTimer(timer - 1);
      }

      if (timer === 0) {
        if (minutes === 0) {
          clearInterval(interval);
        } else {
          setTimer(30);
          setMinutes(minutes - 1);
        }
      }
    }, 1000);
    return () => {
      clearInterval(interval);
    };
  }, [timer, minutes]);

  return (
    <>
      {/* <div className="d-flex sample">
      <div className="row w-100">
        <div className="col-md-6 col-lg-6 d-flex align-items-center justify-content-center p-5">
          <img
            src={otpImg}
            className="object-fit-cover rounded-5"
            alt="otp-img"
          />
        </div>
        <div
          className="col-md-6 col-lg-6 d-flex "
          style={{ boxShadow: "rgba(149, 157, 165, 0.2) 0px 8px 24px" }}
        >
          <div
            className="align-content-center p-4"
            style={{
              backgroundColor: "white",
              borderRadius: "10px",
              width: "100%",
            }}
          >
            <h5 className="text-center mb-4">
              We have sent OTP on your mobile number
            </h5>
            <h4 className="text-center mb-4">Please Enter OTP</h4>
            <div>
              <div className="mb-3 d-flex align-items-center justify-content-center">
                <OtpInput
                  value={otp}
                  onChange={setOtp}
                  numInputs={6}
                  renderInput={(props) => (
                    <input
                      {...props}
                      className="form-control"
                      onKeyPress={(e) => {
                        if (!/[0-9]/.test(e.key)) {
                          e.preventDefault();
                        }
                      }}
                    />
                  )}
                  inputStyle={{
                    width: "50px",
                    height: "50px",
                    marginRight: "10px",
                    textAlign: "center",
                    border: "1px solid #ccc",
                    borderRadius: "5px",
                    marginTop: "10px",
                  }}
                  isInputNum={true}
                />
              </div>
              {error && (
                <div className="d-flex justify-content-center mb-3">
                  <p className="text-danger">{error}</p>
                </div>
              )}
             
              <div className="d-grid gap-3 d-md-flex justify-content-md-center mt-4">
               
                <button
                  className="theme-btn btn-style-one"
                  onClick={handleSubmit}
                >
                  Verify OTP
                </button>
              </div>

              {minutes === 0 && timer === 0 ? (
                <>
                  <div className="text-center mt-3">
                    Not received your code?{" "}
                    <span
                      onClick={resendOtp}
                      className="text-danger cursor"
                      style={{ cursor: "pointer" }}
                    >
                      {" "}
                      Resend code
                    </span>
                  </div>
                </>
              ) : (
                <>
                  <div className="text-center mt-3">
                    Not received your code?{" "}
                    <span className="text-danger">
                      {minutes < 10 ? `0${minutes}` : minutes}:
                      {timer < 10 ? `0${timer}` : timer}
                    </span>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </div> */}

      <div
        className="d-flex justify-content-center align-items-center sample"
        style={{ background: "#ffd4e7", height: "100vh" }}
      >
        <div className="row w-100 d-flex justify-content-center align-items-center">
          <div
            className=" d-flex justify-content-center  col-sm-11 col-xs-12 "
            style={{
              // boxShadow: "rgba(149, 157, 165, 0.2) 0px 8px 24px",
              width: "450px",
              height: "450px",
              // borderRadius: "20px",
            }}
          >
            <div
              className="align-content-center p-4"
              style={{
                backgroundColor: "white",
                boxShadow: "rgba(149, 157, 165, 0.2) 0px 8px 24px",
                borderRadius: "25px",
                width: "100%",
              }}
            >
              <div className="d-flex justify-content-center align-items-center">
                <Lottie
                  animationData={otpgif}
                  loop={true}
                  style={{ width: 110, height: 110 }}
                />
              </div>
              <h4 className="text-center mb-2 fw-600">Verify Phone Number</h4>

              <div
                className="text-center mb-2"
                style={{ color: "grey", fontWeight: "400", fontSize: "14px" }}
              >
                We have sent OTP on your mobile number
              </div>

              <div>
                <div className="mb-3 d-flex align-items-center justify-content-center p-sm-2">
                  <OtpInput
                    value={otp}
                    onChange={setOtp}
                    numInputs={6}
                    renderInput={(props) => (
                      <input {...props} className="form-control" />
                    )}
                    inputStyle={{
                      width: "45px",
                      height: "45px",
                      marginRight: "10px",
                      textAlign: "center",
                      border: "1px solid #ccc",
                      borderRadius: "5px",
                      marginTop: "10px",
                    }}
                  />
                </div>
                {error && (
                  <div className="d-flex justify-content-center mb-3">
                    <p className="text-danger">{error}</p>
                  </div>
                )}
                {/* <div className="d-flex justify-content-center mb-3">
                <p>
                  Time Remaining:{" "}
                  <span className="text-danger">
                    {minutes < 10 ? `0${minutes}` : minutes}:
                    {timer < 10 ? `0${timer}` : timer}
                  </span>
                </p>
              </div>
              <div className="d-grid gap-3 d-md-flex justify-content-md-center mt-4">
                <button
                  type="button"
                  disabled={timer > 0 || minutes > 0}
                  style={{
                    color: timer > 0 || minutes > 0 ? "#DFE3E8" : "#FF5630",
                  }}
                  onClick={resendOtp}
                >
                  Resend OTP
                </button>
                <button className="btn btn-primary" onClick={handleSubmit}>
                  Verify OTP
                </button>
              </div> */}

                <div className="d-grid gap-3 d-md-flex justify-content-md-center mt-4">
                  {/* <button
                  type="button"
                  disabled={timer > 0 || minutes > 0}
                  style={{
                    color: timer > 0 || minutes > 0 ? "#DFE3E8" : "#FF5630",
                  }}
                >
                  Resend OTP
                </button> */}
                  <button
                    className="theme-btn btn-style-one"
                    style={{ padding: "10px 14px" }}
                    onClick={handleSubmit}
                  >
                    Verify OTP
                  </button>
                </div>

                {minutes === 0 && timer === 0 ? (
                  <>
                    <div
                      className="text-center mt-3"
                      style={{ color: "grey", fontWeight: "400" }}
                    >
                      Not received your code?{" "}
                      <span
                        onClick={resendOtp}
                        className="cursor"
                        style={{
                          cursor: "pointer",
                          color: "#96144d",
                          fontWeight: "600",
                        }}
                      >
                        {" "}
                        Resend code
                      </span>
                    </div>
                  </>
                ) : (
                  <>
                    <div className="text-center mt-3">
                      Not received your code?{" "}
                      <span className="text-danger">
                        {minutes < 10 ? `0${minutes}` : minutes}:
                        {timer < 10 ? `0${timer}` : timer}
                      </span>
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Otp;
